import { css } from 'styled-components';
import token from 'styled-token';

/** @mixin buttonStateMixin */
/**
 * @method
 */
export var buttonStateMixin = function buttonStateMixin(state) {
  if (state === void 0) {
    state = '';
  }
  return function (props) {
    var buttonType = props.buttonType,
      inverse = props.inverse,
      bare = props.bare,
      borderless = props.borderless,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? true : _props$interactive;
    var variant = "" + buttonType + (inverse ? 'Inverse' : '');
    return token({
      backgroundColor: "Button." + variant + ".backgroundColor" + state,
      backgroundColorHover: "Button." + variant + ".backgroundColor" + state + "Hover",
      backgroundColorActive: "Button." + variant + ".backgroundColor" + state + "Active",
      borderColor: "Button." + variant + ".borderColor" + state,
      borderColorHover: "Button." + variant + ".borderColor" + state + "Hover",
      borderColorActive: "Button." + variant + ".borderColor" + state + "Active",
      color: "Button." + variant + ".fontColor" + state,
      colorHover: "Button." + variant + ".fontColor" + state + "Hover",
      colorActive: "Button." + variant + ".fontColor" + state + "Active"
    }, function (_ref) {
      var backgroundColor = _ref.backgroundColor,
        backgroundColorHover = _ref.backgroundColorHover,
        backgroundColorActive = _ref.backgroundColorActive,
        borderColor = _ref.borderColor,
        borderColorHover = _ref.borderColorHover,
        borderColorActive = _ref.borderColorActive,
        color = _ref.color,
        colorHover = _ref.colorHover,
        colorActive = _ref.colorActive;
      var currentState = /*#__PURE__*/css(["background-color:", ";border-color:", ";color:", ";", ""], backgroundColor, borderless && state !== 'Pressed' ? 'transparent' : borderColor, color, !borderless && state === 'Pressed' && interactive ? "\n              &:hover:not(:disabled) {\n                background-color: " + backgroundColorHover + ";\n                border-color: " + borderColorHover + ";\n                color: " + colorHover + ";\n              }\n              &:active:not(:disabled) {\n                background-color: " + backgroundColorActive + ";\n                border-color: " + borderColorActive + ";\n                color: " + colorActive + ";\n              }\n            " : null);
      if (bare) {
        currentState = css(["background-color:", ";border-color:", ";color:", ";"], state === '' ? 'transparent' : backgroundColor, state !== 'Pressed' ? 'transparent' : borderColor, color);
      }
      return currentState;
    })(props);
  };
};